import * as ActionTypes from './actionTypes';

export function selectProject(projectId) {
  return {
    type: ActionTypes.PROJECTS_SELECT_ITEMS,
    payload: {
      projectId,
    },
  };
}

export function deselectAll() {
  return {
    type: ActionTypes.PROJECT_DESELECT_ALL,
  };
}

export function toggleBatchEdit() {
  return {
    type: ActionTypes.PROJECTS_TOGGLE_BATCH_EDIT,
  };
}

export function addProject() {
  return {
    type: ActionTypes.PROJECTS_ADD,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/projects.js